import type { VThemeConfig } from './type';

export const VUEX_THEME: VThemeConfig = {
  name: 'Vuex',

  primary: {
    100: '#1b2d57',
    200: '#1b2d57',
    300: '#1b2d57',
    400: '#1b2d57',
    500: '#0b1b3e',
    600: '#06112b',
    700: '#06112b',
    800: '#06112b',
    900: '#06112b',
  },
  secondary: {
    100: '#3a6aff',
    200: '#3a6aff',
    300: '#3a6aff',
    400: '#3a6aff',
    500: '#2a58f6',
    600: '#2046d9',
    700: '#2046d9',
    800: '#2046d9',
    900: '#2046d9',
  },
  tertiary: {
    100: '#eaf7fd',
    200: '#dff2fb',
    300: '#d1eef9',
    400: '#b8e3f4',
    500: '#9fd8ef',
    600: '#85b6d4',
    700: '#85b6d4',
    800: '#85b6d4',
    900: '#85b6d4',
  },
};

export const VUEFLOW_THEME: VThemeConfig = {
  name: 'VueFlow',

  primary: {
    100: '#0b2e73',
    200: '#0b2e73',
    300: '#0b2e73',
    400: '#0b2e73',
    500: '#002055',
    600: '#00163d',
    700: '#00163d',
    800: '#00163d',
    900: '#00163d',
  },
  secondary: {
    100: '#006199',
    200: '#006199',
    300: '#006199',
    400: '#006199',
    500: '#004c7c',
    600: '#003a61',
    700: '#003a61',
    800: '#003a61',
    900: '#003a61',
  },
  tertiary: {
    100: '#e3fff1',
    200: '#ccfbe5',
    300: '#b8f5d0',
    400: '#66d7a0',
    500: '#00b668',
    600: '#009358',
    700: '#009358',
    800: '#009358',
    900: '#009358',
  },
};
